import React, { useState } from 'react';
import ColorField from './ColorField';
import RegisterCardPreview from './RegisterCardPreview';
import { resolveImageUrl, DEFAULT_LOGO, DEFAULT_CARD_BG, withCacheBust } from '../../utils/imageDefaults';
import { resolveTemplateColor } from '../../utils/templateColors';
import { createLocalPreviewUrl, revokeLocalPreviewUrl } from '../../utils/filePreview';
import { validateImageFile, MAX_IMAGE_SIZE_LABEL } from '../../utils/imageUpload';

const GeneralTab = ({ user, updateUser, uploadImage }) => {
  const [localLogo, setLocalLogo] = useState(null);
  const [localBg, setLocalBg] = useState(null);

  const logoPreview = localLogo || resolveImageUrl(user.logoUrl, DEFAULT_LOGO);
  const bgPreview = localBg || resolveImageUrl(user.backgroundUrl, DEFAULT_CARD_BG);

  const previewUser = {
    ...user,
    logoUrl: logoPreview,
    backgroundUrl: bgPreview,
  };

  const handleImageUpload = async (e, { setPreview, updateField, fallbackLabel }) => {
    const file = e.target.files[0];
    if (!file) return;

    const validation = validateImageFile(file);
    if (!validation.ok) {
      alert(validation.message);
      e.target.value = '';
      return;
    }

    const blob = createLocalPreviewUrl(file);
    setPreview(blob);
    try {
      const endpoint = updateField === 'logoUrl'
        ? `/images/logo/${user._id}`
        : `/images/background/${user._id}`;
      const url = withCacheBust(await uploadImage(endpoint, file), { force: true });
      updateUser(updateField, url);
      setPreview(url);
    } catch (err) {
      setPreview(null);
      alert(err?.message || `Не удалось загрузить ${fallbackLabel}`);
    } finally {
      revokeLocalPreviewUrl(blob);
      e.target.value = '';
    }
  };

  const handleLogoUpload = (e) => handleImageUpload(e, {
    setPreview: setLocalLogo,
    updateField: 'logoUrl',
    fallbackLabel: 'логотип',
  });

  const handleBgUpload = (e) => handleImageUpload(e, {
    setPreview: setLocalBg,
    updateField: 'backgroundUrl',
    fallbackLabel: 'фон',
  });

  return (
    <div className="admin-section">
      <h2>Общие настройки</h2>
      <div className="admin-cards-row admin-general-layout">
        <div className="admin-card-group">
          <h3>Магазин</h3>
          <label className="admin-field">
            <span>Название</span>
            <input type="text" value={user.accountName || ''} onChange={(e) => updateUser('accountName', e.target.value)} />
          </label>
          <label className="admin-field admin-checkbox">
            <input type="checkbox" checked={!!user.isIssueCards} onChange={(e) => updateUser('isIssueCards', e.target.checked)} />
            <span>Выдавать карты через Telegram</span>
          </label>
          <label className="admin-field admin-checkbox">
            <input type="checkbox" checked={!!user.needVerification} onChange={(e) => updateUser('needVerification', e.target.checked)} />
            <span>Код при списании бонусов</span>
          </label>
        </div>

        <div className="admin-card-group">
          <h3>Регистрация · брендинг</h3>
          <p className="admin-hint">Логотип, фон и цвета на экране выбора магазина</p>
          <RegisterCardPreview user={previewUser} />
          <div className="admin-brand-previews">
            <div className="admin-logo-preview">
              <img key={logoPreview} src={logoPreview} alt="Логотип" onError={(e) => { e.target.src = DEFAULT_LOGO; }} />
            </div>
            <div className="admin-bg-preview admin-bg-preview-sm">
              <img key={bgPreview} src={bgPreview} alt="Фон" onError={(e) => { e.target.src = DEFAULT_CARD_BG; }} />
            </div>
          </div>
          <label className="admin-field">
            <span>Логотип</span>
            <input type="file" accept="image/*" onChange={handleLogoUpload} />
            <span className="admin-hint admin-hint-inline">JPG, PNG, WebP · не больше {MAX_IMAGE_SIZE_LABEL}</span>
          </label>
          <label className="admin-field">
            <span>Фон</span>
            <input type="file" accept="image/*" onChange={handleBgUpload} />
            <span className="admin-hint admin-hint-inline">JPG, PNG, WebP · не больше {MAX_IMAGE_SIZE_LABEL}</span>
          </label>
          <div className="admin-colors-grid admin-colors-grid-vertical">
            <ColorField
              label="Цвет фона"
              value={resolveTemplateColor(user.mainColor, 'mainColor')}
              onChange={(v) => updateUser('mainColor', v)}
            />
            <ColorField
              label="Цвет текста"
              value={resolveTemplateColor(user.textColor, 'textColor')}
              onChange={(v) => updateUser('textColor', v)}
            />
            <ColorField
              label="Цвет подписей"
              value={resolveTemplateColor(user.labelColor, 'labelColor')}
              onChange={(v) => updateUser('labelColor', v)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralTab;
